export default __webpack_public_path__ + "static/media/pinapple.25741d2f.jpg";